import { render, staticRenderFns } from "./RegisterSidebar.vue?vue&type=template&id=534c5670&scoped=true&"
import script from "./RegisterSidebar.vue?vue&type=script&lang=js&"
export * from "./RegisterSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSidebar.vue?vue&type=style&index=0&id=534c5670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c5670",
  null
  
)

export default component.exports